import React from 'react';
import './PassList.css';

const PassList = () => {
  /* Change this if you want to change any of your "top VPN" rankings items */
  const topPassMans = [
    {
      tName: ' NordPass',
      tRating: '9.8/10',
      tUrl: 'https://nordpass.com/',
      tImg: 'https://cdn.worldvectorlogo.com/logos/nordpass.svg',
      tDescription: 'User Friendly and E2E encryption, known for its trust from NordVPN',
    },
    {
      tName: ' ProtonPass',
      tRating: '9.5/10',
      tUrl: 'https://proton.me/pass',
      tImg: 'https://cdn.worldvectorlogo.com/logos/proton-mail.svg',
      tDescription: 'Good value if you have Proton unlimited subscription',
    },
    {
      tName: ' Bitwarden',
      tRating: '9.1/10',
      tUrl: 'https://bitwarden.com/',
      tImg: 'https://cdn.worldvectorlogo.com/logos/bitwarden.svg',
      tDescription: 'Best free and open source password manager',
    },
    {
      tName: ' 1Password',
      tRating: '8.9/10',
      tUrl: 'https://1password.com/',
      tImg: 'https://cdn.worldvectorlogo.com/logos/1password.svg',
      tDescription: 'Simple and easy to use',
    },
  ];

  return (
    <div className="tier-list">
      <img alt="VPN Guides Banner" className="logo-banner" src="https://i.e-z.host/iiuvfmip.png"></img>
        <div className="top-container">
        <div className="titles-container">
        <h3 className="main-heading">
          Why use VPN Guides?
        </h3>
        <p>
        We are 100% honest and upfront about everything we do. Every VPN we rank and list is a VPN that has been tried and tested! We are also fully open to feedback, so feel free 
        to give any feedback you may have, good or bad.
        </p>
      </div>
      </div>
      <h3>Our top PWMs:</h3>
      <table className="top-vpn-table">
        <thead>
          <tr>
            <th>#</th>
            <th>PWM</th>
            <th>Description</th>
            <th>Rating</th>
          </tr>
        </thead>
        <tbody>
          {topPassMans.map((pwm, index) => (
            <tr key={index} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
              <td className="number-cell">{index + 1}</td>
              <td className="vpn-cell">
                <a href={pwm.tUrl} target="_blank" rel="noreferrer">
                  {pwm.tName}
                </a>
              </td>
              <td className="description-cell">{pwm.tDescription}</td>
              <td className="rating-cell">{pwm.tRating}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="updates-container">
        <h3>VPN Guides Updates - 12/2025:</h3>
        <p>Added Antivirus Tier List.</p>
        <p>----------------------------------------------------------------</p>
        <h3>VPN Guides Updates - 10/2025:</h3>
        <p>Website updates: Updated styling, improved table layouts, and enhanced user experience</p>
        <p>----------------------------------------------------------------</p>
        <h3>VPN Guides Updates - 1/2025:</h3>
        <p>Updated tier list order and top VPNs order</p>
        <p>----------------------------------------------------------------</p>
        <h3>VPN Guides Updates - 1/2025:</h3>
        <p>Updated VPN tier list and added a Password Manager tier list!</p>
        <p>----------------------------------------------------------------</p>
        <h3>VPN Guides Updates - 8/2024:</h3>
        <p>Initial release of the VPN Guides rankings!</p>
      </div>
    </div>
  );
};

export default PassList;
